import { useEffect, useCallback } from 'react';

const MessageListeners = ({ eventEmitter, applyStoreAction, largeDelayedApplyStoreAction, currentUserId }) => {
    const messageAdded = useCallback(payload => {
        const withDelay = payload.author === currentUserId && !payload.force;

        // Add after delay, so message can be added before the socket
        (!withDelay ? applyStoreAction : largeDelayedApplyStoreAction)({
            type: 'MESSAGE_ADD_SOCKET',
            payload: { message: payload }
        });
    }, [currentUserId, applyStoreAction, largeDelayedApplyStoreAction]);

    const messageEdited = useCallback(message => {
        applyStoreAction({
            type: 'MESSAGE_UPDATE_SOCKET',
            payload: {
                message,
                messageId: message.id
            }
        });
    }, [applyStoreAction]);

    const messageRemoved = useCallback(({ id, task_id, subtype }) => {
        applyStoreAction({
            type: 'MESSAGE_REMOVE_SOCKET',
            payload: {
                messageId: id,
                message: {
                    task: task_id,
                    subtype
                }
            }
        });
    }, [applyStoreAction]);

    const messagesSeen = useCallback(({ ids, member_id }) => {
        applyStoreAction({
            type: 'MESSAGES_SEE_SOCKET',
            payload: {
                messageIds: ids,
                userId: member_id
            }
        })
    }, [applyStoreAction]);

    const systemMessageAdded = useCallback(message => {
        applyStoreAction({
            type: 'MESSAGE_ADD_SOCKET',
            payload: { message }
        })
    }, [applyStoreAction]);

    const listen = () => {
        eventEmitter.on('message_added', messageAdded);
        eventEmitter.on('message_edited', messageEdited);
        eventEmitter.on('message_removed', messageRemoved);
        eventEmitter.on('new_system_message', systemMessageAdded);
        eventEmitter.on('messages_seen', messagesSeen);

        return () => {
            eventEmitter.off('message_added', messageAdded);
            eventEmitter.off('message_edited', messageEdited);
            eventEmitter.off('message_removed', messageRemoved);
            eventEmitter.off('new_system_message', systemMessageAdded);
            eventEmitter.off('messages_seen', messagesSeen);
        };
    };

    useEffect(listen, [eventEmitter, messageAdded, messageEdited, messageRemoved, systemMessageAdded, messagesSeen]);

    return null;
}

export default MessageListeners;
